module.exports = __webpack_public_path__ + "media/images/ic-number-os-dcc55691c65e757fc62eff3c8abf1333.svg";